import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = () =>
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  useEffect(() => {
    refresh();
  }, []);
  const login = async (email, senha) => {
    const r = await api.post("/auth/login", { email, senha });
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return <Ctx.Provider value={{ user, setUser, login, logout, refresh }}>{children}</Ctx.Provider>;
}

export const can = (user, perm) => !!user && (user.permissoes?.includes("*") || user.permissoes?.includes(perm));
